// «접수 미확인»(registerConfirm not_found·check_failed) 다시 확인 — 서플라이어허브 등록 상태 목록(WIMS)에서 찾기만 한다. 전송 없음(읽기만).
// 화면 «등록 전송»은 확장이 «제출 뒤 완료 글»만 알려 줘 markSentUnconfirmed(not_found)로 끝났고, 아무도 허브를 다시 보지 않아
// 영원히 «접수 미확인»이었다(10-21 #450 뒤 mostic 29건). 잣대는 도구 재확인과 같다(tool-exec/rocket-submit.js hasPendingOption·statusDone·saveSent recheck):
//   quotationId = "CID-" + coupangDoc.qvtRequestId 로 찾음 → 보이면 등록됨(state REJECTION 이면 반려) · 못 찾으면 not_found 유지 · 조회 실패면 check_failed
// ⚠ 허브 목록은 «아직 안 끝난 것»만 보여 준다(검수 끝난 건은 빠짐 — tool-exec/rocket.js WIMS 주석). 못 찾음 ≠ 안 보냄.
export const HUB_REJECTED = 'REJECTION'
export const HUB_PAGE_SIZE = 100
export const HUB_MAX_PAGES = 10
const DAY_MS = 24 * 60 * 60 * 1000
const STATE_LABELS = { INSPECTION: '상품 검수중', INSPECTION_COMPLETE: '상품 검수 완료', REJECTION: '상품 검수 반려' }
const STEP_LABELS = { ONBOARDED: '상품 등록 접수', HOTW: '가격·정책 검토', R21: '상품 정보 검토', PO: '발주서 발행' }

/** 보냈는데 허브 확인 전(재확인 대상) — 도구 hasPendingOption 과 같은 잣대. registered:true·반려는 아니다 */
export function needsHubRecheck(p) {
  if (!p || p.registered === true) return false
  const rc = p.registerConfirm
  return !!(rc && ['not_found', 'check_failed'].includes(rc.status))
}

/** 허브 목록의 quotationId — WIMS quotationId 는 "CID-" + 초안 qvtRequestId(도구 confirmDone 과 같다). 모르면 null */
export function quotationIdOf(p) {
  const rc = (p && p.registerConfirm) || {}
  if (rc.quotationId) return String(rc.quotationId)
  const qvt = p && p.coupangDoc && p.coupangDoc.qvtRequestId
  return qvt ? `CID-${qvt}` : null
}

/** 초안 번호(docId) — 화면 전송 건은 견적 번호 없이 이것만 있다(10-27 not_found 1188건 · 딩톡 #46). 모르면 null */
export function docIdOf(p) {
  const rc = (p && p.registerConfirm) || {}
  const v = rc.docId || (p && p.coupangDoc && p.coupangDoc.docId)
  return v ? String(v) : null
}

/** 견적 번호를 모르고 초안 번호만 아는 «접수 미확인» 건 — 서버 재확인(접수 목록에서 docId 로 견적 번호를 받아 허브 확인) 대상 */
export function needsServerRecheck(p) {
  return needsHubRecheck(p) && !quotationIdOf(p) && !!docIdOf(p)
}

/** 자동 재확인할 때가 됐나 — 마지막 확인(registerConfirm.at)에서 minGapMs 이상 지났고 견적 번호를 알 때.
 *  byDoc(서버 재확인 길이 있을 때 — CLI 데몬)이면 견적 번호 없이 초안 번호만 아는 건도(딩톡 #46 — 10-28 운영 접수 미확인 2,323 중 1,638) */
export function dueForAutoRecheck(p, now, minGapMs, { byDoc = false } = {}) {
  if (!needsHubRecheck(p)) return false
  if (!quotationIdOf(p) && !(byDoc && docIdOf(p))) return false
  const at = Number(p.registerConfirm.at) || 0
  return now - at >= minGapMs
}

// 자동 재확인 한 번에 서버로 보낼 초안 번호만 아는 건 상한 — 서버 재확인 한 묶음(화면 HUB_SERVER_RECHECK_CHUNK · 도구 상한 50)과 같다
export const AUTO_SERVER_RECHECK_MAX = 50
/** 자동 재확인 대상 — 견적 번호 아는 건 전부(화면이 허브 목록 쪽으로 한꺼번에 봄) + 초안 번호만 아는 건은 최근 보낸 것부터 maxByDoc 건.
 *  확인한 건은 registerConfirm.at 이 새로 적혀 minGap 동안 빠지므로 다음 바퀴에 그다음 묶음이 온다(밀린 1,638건도 조금씩) */
export function pickAutoRecheck(products, now, minGapMs, { byDoc = false, maxByDoc = AUTO_SERVER_RECHECK_MAX } = {}) {
  const due = (products || []).filter(p => dueForAutoRecheck(p, now, minGapMs, { byDoc }))
  const withQ = due.filter(p => quotationIdOf(p))
  // 등록ID 앞 6자리가 YYMMDD 라 글자 역순 = 최근 것부터
  const docOnly = due.filter(p => !quotationIdOf(p))
    .sort((a, b) => String(b.registrationId || '').localeCompare(String(a.registrationId || '')))
    .slice(0, Math.max(0, maxByDoc))
  return [...withQ, ...docOnly]
}

/** 조회 시작(ms) — 등록ID 앞 6자리(YYMMDD, 그날 이후에 보냈다)와 마지막 확인 하루 전 중 가장 앞(도구 statusStart 와 같은 뜻 · 넓게) */
export function hubStartMs(products, now) {
  let start = now - DAY_MS
  for (const p of products || []) {
    const m = /^(\d{2})(\d{2})(\d{2})/.exec(String((p && p.registrationId) || ''))
    if (m) {
      const t = new Date(2000 + Number(m[1]), Number(m[2]) - 1, Number(m[3])).getTime()
      if (!isNaN(t)) start = Math.min(start, t)
    }
    const at = Number(p && p.registerConfirm && p.registerConfirm.at)
    if (at) start = Math.min(start, at - DAY_MS)
  }
  const d = new Date(start)
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
}

/** 반려 사유 한 줄 — 막힌 단계 + 사유 코드(화면 등록 심사 상태 표와 같은 원문 코드) */
function rejectReasonOf(hit) {
  const steps = Array.isArray(hit && hit.steps) ? hit.steps : []
  const s = steps.find(x => x && x.progress === 'REJECTED')
  if (!s) return ''
  const codes = (Array.isArray(s.tooltips) ? s.tooltips : []).map(t => t && t.code).filter(Boolean)
  return [STEP_LABELS[s.step] || s.step, codes.join(' / ')].filter(Boolean).join(': ').slice(0, 300)
}

/**
 * 확인 결과를 상품에 적고 서버에 저장할 칸(updateFields)을 돌려준다 — 도구 saveSent recheck 와 같은 칸.
 * outcome: { hit } 허브에서 찾음 · { notFound: true } 끝 쪽까지 봤는데 없음 · { error } 조회 실패
 * set(obj, key, value) — 화면은 this.$set, 시험은 대입
 */
export function applyHubResult(p, outcome, set, now = Date.now()) {
  const prev = p.registerConfirm || {}
  const qid = quotationIdOf(p)
  const docId = prev.docId || (p.coupangDoc && p.coupangDoc.docId) || null
  const base = { at: now, docId, ...(qid ? { quotationId: qid } : {}) }
  const hit = outcome && outcome.hit
  let rc
  if (hit && hit.state === HUB_REJECTED) {
    const why = rejectReasonOf(hit)
    rc = { status: 'rejected', ...base, hubState: STATE_LABELS[hit.state] || hit.state, ...(why ? { rejectReason: why } : {}) }
  } else if (hit) {
    rc = { status: 'found', ...base, ...(hit.state ? { hubState: STATE_LABELS[hit.state] || hit.state } : {}) }
  } else if (outcome && outcome.error) {
    rc = { status: 'check_failed', ...base, error: String(outcome.error).slice(0, 200) }
  } else {
    rc = { status: 'not_found', ...base }
  }
  set(p, 'registerConfirm', rc)
  const updateFields = { registerConfirm: rc }
  if (rc.status === 'found') Object.assign(updateFields, markFound(p, set))
  return updateFields
}

/** 등록됨으로 올린다(화면) — 저장할 칸을 돌려준다 */
function markFound(p, set) {
  set(p, 'registered', true)
  set(p, 'verified', true)
  const fields = { registered: true, verified: true }
  const options = Array.isArray(p.options) ? p.options : []
  for (const o of options) {
    set(o, 'registrationStatus', 'registered')
    set(o, 'verified', true)
  }
  if (options.length) Object.assign(fields, { 'options.$[].registrationStatus': 'registered', 'options.$[].verified': true })
  return fields
}

const SERVER_STATUSES = ['found', 'rejected', 'not_found', 'check_failed']
/**
 * 서버 재확인 결과 한 줄(도구 결과 products[]: registerConfirm=상태 글 · hubState · rejectReason · quotationId)을 화면에 적는다.
 * 판정·저장은 서버가 끝냈다(docId 가 같은 접수 줄의 견적 번호로만 허브를 봄) — 화면은 그대로 보여 주기만 한다. 상태가 없거나 모르는 값이면 안 바꾸고 null
 */
// 서버가 결과를 DB 에 저장하지 못한 줄(saveWarning) — 화면만 «등록완료»로 올리면 새로고침 때 되돌아가 거짓이 된다. 바꾸지 않고 'save_failed'
export const SERVER_SAVE_FAILED = 'save_failed'
export function applyServerRecheck(p, row, set, now = Date.now()) {
  const status = row && row.registerConfirm
  if (!SERVER_STATUSES.includes(status)) return null
  if (row.saveWarning) return SERVER_SAVE_FAILED
  const prev = p.registerConfirm || {}
  const rc = {
    status, at: now, docId: docIdOf(p),
    ...(row.quotationId ? { quotationId: String(row.quotationId) } : (prev.quotationId ? { quotationId: prev.quotationId } : {})),
    ...(row.hubState ? { hubState: row.hubState } : {}),
    ...(status === 'rejected' && row.rejectReason ? { rejectReason: row.rejectReason } : {}),
  }
  set(p, 'registerConfirm', rc)
  if (status === 'found') markFound(p, set)
  return status
}
